import { cx } from '../cx';

const SIZE = { sm: 'size-4', md: 'size-5', lg: 'size-6' } as const;

export type SpinnerProps = {
  size?: keyof typeof SIZE;
  /** Accessible name; without one the spinner is decorative (the control says aria-busy). */
  label?: string;
  className?: string;
};

/** An indeterminate loading ring in the current text colour. Stops spinning under reduced motion. */
export function Spinner({ size = 'md', label, className }: SpinnerProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={cx(SIZE[size], 'animate-spin motion-reduce:animate-none', className)}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
